
















import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';
import GEFormFields from '@/Types/GEFormFields';
import {SchemaFieldIfCallback} from '@/Types/SchemaField';

@Component({})
export default class YesNoInput extends Vue {
    static COMPONENT_NAME = 'yes-no-input'

    static YES = 'yes'
    static NO = 'no'

    static isYes(fieldName: string): SchemaFieldIfCallback {
        return (fields: GEFormFields) => fields[fieldName] === YesNoInput.YES
    }

    static isNo(fieldName: string): SchemaFieldIfCallback {
        return (fields: GEFormFields) => fields[fieldName] === YesNoInput.NO
    }

    @Prop({type: Object, default: () => {}}) options!: Record<string, string>
    @Prop({type: Boolean, default: false}) uncertain!: false

    get appendedOptions(): Record<string, string> {
        const opts = {
            [YesNoInput.YES]: 'Yes',
            [YesNoInput.NO]: 'No',
        }

        if (this.uncertain) {
            opts.uncertain = 'Uncertain';
        }

        return {
            ...opts,
            ...this.$props.options
        }
    }
}
